import { render, staticRenderFns } from "./Step1-Content.vue?vue&type=template&id=0c770ee2&"
import script from "./Step1-Content.vue?vue&type=script&lang=js&"
export * from "./Step1-Content.vue?vue&type=script&lang=js&"
import style0 from "./Step1-Content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports